exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".otp-text {\r\n    margin-top: 20px;\r\n}\r\n\r\n.otp-text {\r\n    color: rgb(191, 124, 121);\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n}", ""]);

// exports
